import { ButtonBase, Divider, Stack, Typography } from '@mui/material'
import { InputWithDropdown } from 'components/InputWithDropdown/InputWithDropdown'
import { FieldArray } from 'formik'
import { t } from 'i18next'
import theme from 'lib/theme'
import { Fragment, useState } from 'react'
import { v4 as getRandomId } from 'uuid'
import { ProductAttribute, ProductAttributeGroup } from 'types/model/product'
import { AddAttributeModal } from './AddAttributeModal'
import { Attribute } from './Attribute'
import { EditAttributeModal } from './EditAttributeModal'

export const AttributeGroup = ({
  attributeGroup,
  index,
}: {
  attributeGroup: ProductAttributeGroup
  index: number
}) => {
  const formatFieldName = (name: string) => {
    return `attributeGroup.${index}.${name}`
  }
  const [attributeId, setAttributeId] = useState<string | null>(null)
  const [addModal, setAddModal] = useState({
    right: false,
  })
  const [editModal, setEditModal] = useState({
    right: false,
  })
  const [id, setId] = useState(attributeGroup.productAttribute[0].id)
  const handleCloseModal = () => {
    setAddModal({ right: false })
    setEditModal({ right: false })
  }

  const handleOpenModal = (
    push: (attribute: Partial<ProductAttribute>) => void
  ) => {
    const newId = getRandomId()
    setId(newId)
    push({ id: newId })
    setAddModal({ right: true })
  }

  const handleOpenEditModal = (id: string) => {
    setAttributeId(id)
    setEditModal({ right: true })
  }

  return (
    <>
      <Stack>
        <InputWithDropdown
          label={t('groupName')}
          value={
            attributeGroup.productAttributeGroupName.options[
              attributeGroup.productAttributeGroupName.contentLanguage
            ]
          }
          selectedOption={
            attributeGroup?.productAttributeGroupName?.contentLanguage
          }
          dropdownFieldName={formatFieldName(
            'productAttributeGroupName.contentLanguage'
          )}
          inputFieldName={formatFieldName('productAttributeGroupName.options')}
          inputOptions={attributeGroup?.productAttributeGroupName?.options}
        />
        <FieldArray name={formatFieldName('productAttribute')}>
          {({ push }) => (
            <>
              {attributeGroup.productAttribute.map((attribute) => (
                <Fragment key={attribute.id}>
                  <Attribute
                    handleOpenEditModal={handleOpenEditModal}
                    attribute={attribute}
                    language={
                      attributeGroup.productAttributeGroupName.contentLanguage
                    }
                  />
                </Fragment>
              ))}
              <ButtonBase
                onClick={() => handleOpenModal(push)}
                sx={{
                  marginTop: theme.spacing(2),
                  width: 'fit-content',
                  marginLeft: theme.spacing(6),
                }}>
                <Typography
                  variant='body2'
                  sx={{ color: theme.palette.primary.main }}>
                  {t('addAttribute')}
                </Typography>
              </ButtonBase>
              <AddAttributeModal
                id={id}
                modal={addModal}
                handleCloseModal={handleCloseModal}
                attributeGroup={attributeGroup}
                fieldBase={`attributeGroup.${index}.productAttribute`}
              />
              <EditAttributeModal
                attributeId={attributeId}
                attributeGroup={attributeGroup}
                modal={editModal}
                handleCloseModal={handleCloseModal}
                fieldBase={`attributeGroup.${index}.productAttribute`}
              />
            </>
          )}
        </FieldArray>
      </Stack>
      <Divider
        sx={{
          color: theme.palette.neutral.grey7,
          marginTop: theme.spacing(3),
          marginRight: theme.spacing(4),
          width: '100%',
        }}
      />
    </>
  )
}
